import styled, { css } from 'styled-components';
import { token } from '@zillow/constellation';

export const Container = styled.div`
  padding: 0 8px;
`;

export const PriceCardContainer = styled.div<{ isActive: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
  margin-bottom: 16px;
  cursor: ${({ isActive }) => (isActive ? 'default' : 'pointer')};
  border-radius: 4px;
  border: 2px solid
    ${({ isActive }) =>
      css`
        ${isActive ? token('colors.brand') : 'transparent'}
      `};

  &:hover {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
  }
`;

export const PriceCardContainerDisabled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
  box-shadow: none;
  background: ${token('colors.gray200')};

  &:hover {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
  }
`;

export const PriceCardText = styled.div`
  margin-left: 12px;
`;

export const InputError = styled.div`
  font-size: 12px;
  color: ${token('colors.red400')};
  padding-top: 8px;
`;
